module.exports = __webpack_public_path__ + "9235919a639c246de7f1a9f88894ce06.svg";